import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { overviewItems, overviewLoop } from '@/mocks/smart-farm-solution';

export default function Overview() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="方案概述"
          title="构建一体化农业数字体系"
          subtitle="以农业生产为基础、数字技术为支撑、市场需求为牵引，构建「农田感知、智能管理、品质追溯、产品上行、供应链协同、数据运营」的一体化体系。"
        />
        <Reveal className="mt-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {overviewItems.map((item) => (
              <div
                key={item.id}
                className="p-6 rounded-lg bg-background-50 border border-background-200 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(0,0,0,0.08)]"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-5 font-heading font-bold text-foreground-950 text-lg leading-snug">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                <p className="mt-3 text-sm text-foreground-500 leading-relaxed border-t border-background-200 pt-3">
                  {item.note}
                </p>
              </div>
            ))}
          </div>
        </Reveal>

        {/* 持续运营闭环 */}
        <Reveal className="mt-10">
          <div className="p-6 md:p-10 rounded-lg bg-foreground-950 overflow-hidden relative">
            <div className="absolute inset-0 bg-gradient-to-br from-accent-500/10 via-transparent to-primary-500/10 pointer-events-none"></div>
            <div className="relative">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500/15 text-accent-300">
                  <i className="ri-loop-left-line text-xl"></i>
                </div>
                <div>
                  <h3 className="font-heading font-bold text-background-50 text-xl md:text-2xl leading-snug">
                    {overviewLoop.title}
                  </h3>
                  <p className="mt-1 text-sm text-foreground-300">{overviewLoop.desc}</p>
                </div>
              </div>

              <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
                {overviewLoop.flow.map((step, index) => (
                  <div key={step} className="relative flex flex-col items-center gap-2">
                    <div className="w-full flex items-center justify-center">
                      <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 border border-background-50/20 text-background-50 text-sm font-semibold">
                        {index + 1}
                      </span>
                    </div>
                    <span className="text-xs text-foreground-200 text-center whitespace-nowrap">
                      {step}
                    </span>
                    {index < overviewLoop.flow.length - 1 && (
                      <i className="ri-arrow-right-line absolute top-5 -right-2 text-foreground-400 text-xs hidden lg:block"></i>
                    )}
                  </div>
                ))}
              </div>

              <p className="mt-8 text-sm text-foreground-300 leading-relaxed">{overviewLoop.note}</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}